import { render } from "./DefineProjectBlock.vue?vue&type=template&id=eb410fce&scoped=true"
import script from "./DefineProjectBlock.vue?vue&type=script&lang=js"
export * from "./DefineProjectBlock.vue?vue&type=script&lang=js"

import "./DefineProjectBlock.vue?vue&type=style&index=0&id=eb410fce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb410fce"]])

export default __exports__